<template>
  <div class="news-management-container">
    <h1>News Management - Coming Soon</h1>
  </div>
</template>

<script>
export default {
  name: 'NewsManagement'
}
</script>

<style scoped>
.news-management-container {
  padding: 20px;
}
</style>